var F={50:"#FFF1F3",100:"#FFF1F3",200:"#FFE3E6",300:"#FEB8C1",400:"#FD8796",500:"#FD7284",600:"#D76170",700:"#B1505C",800:"#7F3942"};export{F as default};
